import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';

/**
 * 定义 头部活动预告 组件
 */

class ActivityTable extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    render() {
        const { content } = this.props;

        const activityBody =
            content && content.map
                ? content.map((item, index) => {
                      return (
                          <tr key={index}>
                              <td>{item.first}</td>
                              <td>{item.second}</td>
                              <td>{item.third}</td>
                          </tr>
                      );
                  })
                : '';

        return (
            <table className={styles.forenotice}>
                <thead>
                    <tr>
                        <td>会议</td>
                        <td>时间</td>
                        <td>地点</td>
                    </tr>
                </thead>
                <tbody>{activityBody}</tbody>
            </table>
        );
    }
}

ActivityTable.propTypes = {
    content: PropTypes.array,
};
export default errorBoundary(ActivityTable);
